import { DiamondShineIcon, styled } from 'opensolar-ui'
import { FC, useId } from 'react'

const EXPO_GRADIENT = 'linear-gradient(270deg, #1751D0 0%, #CD55A6 100%)'

const Ribbon = styled('div', { name: 'ExpoRibbonTagRibbon' })(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  width: '108px',
  textAlign: 'center',
  padding: '1px 0px 1px 5px',
  borderRadius: 6,
  border: '1px solid transparent',
  boxSizing: 'border-box',
  background: `linear-gradient(${theme.palette.white}, ${theme.palette.white}) padding-box, ${EXPO_GRADIENT} border-box`,
}))

const GradientText = styled('span', { name: 'ExpoRibbonTagText' })({
  background: EXPO_GRADIENT,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontSize: 12,
  fontFamily: 'Inter, sans-serif',
})
interface ExpoRibbonTagProps {
  text?: string
}

const ExpoRibbonTag: FC<ExpoRibbonTagProps> = ({ text = '' }) => {
  const gradientId = useId().replace(/:/g, '')
  return (
    <Ribbon>
      <svg width={0} height={0} aria-hidden>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#CD55A6" />
            <stop offset="100%" stopColor="#1751D0" />
          </linearGradient>
        </defs>
      </svg>
      <DiamondShineIcon size={18} color={`url(#${gradientId})`} />
      <GradientText>{text}</GradientText>
    </Ribbon>
  )
}

export default ExpoRibbonTag
